module.exports = __webpack_public_path__ + "img/加入我们.4ef9171c.png";